import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-300ef286"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "after-sale-details" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Rules", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" This after-sale is provided by   ")
const _hoisted_4 = { class: "apple" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("  store ")
const _hoisted_6 = { class: "after-details-main" }
const _hoisted_7 = { class: "step-box" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Apply")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Processing")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Complete")
const _hoisted_11 = { class: "after-details-conent" }
const _hoisted_12 = { class: "after-state" }
const _hoisted_13 = { class: "after-state-l" }
const _hoisted_14 = {
  key: 0,
  class: "after-time"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Ends in", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_17 = { class: "after-details-bottom" }
const _hoisted_18 = { class: "title" }
const _hoisted_19 = { class: "btn" }

import { ref, inject } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import Header from "@/components/header/header.vue";
import DeatilCard from "./component/afterDetailsCard.vue";
import BottomBtn from "./component/afterBottomBtn.vue";
import KiliButton from "@/components/KiliButton.vue";
import {linkChat,getFilePath,getRuleUrl} from '@/hooks/index'
import { Toast } from 'vant'

export default /*#__PURE__*/_defineComponent({
  __name: 'afterSaleDetails',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const $http: any = inject("$http");
const $store: any = inject("$store");
let btnData = ref([
    {
        plain: false,
        icon: "https://image.kilimall.com/kenya/wap/afterSales/ic_chat_2x.png",
        textColor: '#E04545',
        bordersColor: '#E04545',
        radiusSize: '6px',
        title: 'Contact Seller',
    },
]) as any
/** detailCardData 详情卡片模块数据说明
 * title:'' 当前详情模块标题 
 * textData:[]  当前模块文字数据
 * fileList: [], 当前模块图片视频数据
 * transit: {}, // 当前模块物流信息数据
 */
let detailCardData: any = ref([])
let topData = ref({
    active: 0,
    afterSaleStatus: '',
    time: 0,
    service_overtime: ''
})
// 详情页按钮是否可操作
let btnJurisdictionObj = ref({
    isAvailable: false,// 是否显示申诉按钮
    isEditAddress: false,// 是否可编辑发货地址
})
let showDialog = ref(false)
let popupValue = ref('')
let pageTitle = ref('')
let skipPath = ref('/afterSale')
let formParam = ref({})
// 售后详情id/审核单id
let detailsId = ref({
    checkId: 0,
    storeId: '',
})
let loading=ref(false) // 弹窗的 继续按钮 loading
let storeName = ref('') // 店铺名称
let ruleUrl = ref('') 
let detailAllData = ref({}) 
let imgPathData = {}
const handleBtn = async (item: any) => {
    if (item.title === 'Contact Seller') {
       linkChat($http,$store,detailsId.value.storeId)
    } else {
        if (item.status == 4) {
            // 取消售后
            popupValue.value = 'Please confirm whether to cancel the after-sales service order.'
            showDialog.value = true
        } else if (item.status == 1){
            // 确认的弹窗文案有两种 I: available_type为4时为确认收货, II: available_type为1或6时时为确认方案
            if(item.available_type == 4) {
                 popupValue.value = 'Please confirm whether the goods has been received.'
                 showDialog.value = true
            }else if(item.available_type == 1 ||item.available_type == 6 ){
                 popupValue.value = 'Do you agree with the solution given by the seller？'
                 showDialog.value = true
            }else if(item.available_type == 5){
                router.push({
                       name: 'afterSaleExpress',
                       params:{
                           isDetail:1,
                           name:`${route.query.name}`
                       }
                })
            }
        } else if (item.status == 3){
            appeal()
        }else {
             router.push({
                path: `/afterSaleEvaluation/${route.params.id}?store_id=${detailsId.value.storeId}`,
             })
        }
        formParam.value = {
            check_id: detailsId.value.checkId,
            check_status: item.status
        }
    }

}
const goToRule = () => {
    if(ruleUrl.value){
        window.open(ruleUrl.value)
    }
}
const appeal = () => {
    router.push(`/afterSaleComplaint/${route.params.id}?check_id=${detailsId.value.checkId}&name=${route.query.name}`)
}
const jumpShop = () => {
    //店铺跳转
    router.push({
        name: "shop",
        params: {
            id: detailsId.value.storeId
        },
    });

}
// 操作联系商家
const handleContact = async () => {
    linkChat($http,$store,detailsId.value.storeId)
    showDialog.value = false
};

const handleContinue = async () => {
    showDialog.value = false
    // 确认或取消
    loading.value = true
    const res1: any = await $http.setAfterSaleExpressWay(formParam.value)
    if (res1.code === 200) {
        //   取消或确认后，前往列表页面
       router.push('/afterSale?name=state_all')
    }else{
        Toast(res1.msg)
    }
    loading.value = false
}

// 处理展示的附件
const handleAttachments = (fileList:any,file:any) =>{
        // 进行视频/图片拼接路径及格式设置
                 if (file && file.length) {
                    let fileData = {}
                    // 展示的附件处理
                    file.forEach((item: any) => {
                        fileData = {
                            content: item.attach_type == 1 ? item.content:item.content.replace(imgPathData.media_suffix,imgPathData.media_image_suffix),
                            attach_type: item.attach_type,
                        }
                        fileList.push(fileData)
                    });
                }
}
// 获取并处理详情数据
const getAfterSaleDetail = async () => {
    skipPath.value = `/afterSale?name=${route.query.name}`
    getRuleUrl().then((res: any) => {
        const { aftersale_rules }  = res.agreements
        ruleUrl.value = aftersale_rules.display ?   res.agreements.aftersale_rules.url : ''
    })
    let id = route.params.id
    const filePathRes:any =  await getFilePath() // 获取视频/图片拼接路径及格式
     if(filePathRes){
         imgPathData = filePathRes
     }
    const res: any = await $http.getAfterSaleDetail({ id: id })
    if (res.code === 200) {
        const DETAIL = JSON.parse(JSON.stringify(res.data))
        detailAllData.value  = DETAIL
        let applyInfo = DETAIL.extra.common_info.apply_info // 用户申请售后的信息
        $store.setAfterId({
            afterId: DETAIL.id,
            checkId: DETAIL.available_check_id
        })
        btnJurisdictionObj.value.isEditAddress = DETAIL.available_type && DETAIL.available_action.indexOf(7) != -1
        topData.value = {
            active: DETAIL.status== 0 ? 3: DETAIL.status - 1, // 售后主状态:0-取消;1-审核中;2-执行中;3-完成，会用到的是1-3的状态,所以需要减1 注：当为 0 时表示取消，进度条则是到已完成，故active为3
            afterSaleStatus: DETAIL.service_status_text,
            time: DETAIL.countdown,
            service_overtime: DETAIL.service_overtime,
        }
        detailsId.value = {
            checkId: DETAIL.available_check_id,
            storeId: DETAIL.store_id
        }
        storeName.value = DETAIL.store_name
        btnJurisdictionObj.value.isAvailable = DETAIL.available_action.some((item: any) => item == 3)
        // 商品信息展示是每个详情页默认会展示的
        detailCardData.value.push({
            title: 'My Order Information',
            status: 'goods',
            goodsData: DETAIL.order_goods,
            textData: [{
                label: 'Order Time',
                value: common.tiemstap(DETAIL.created_at * 1000),
            },
            {
                label: 'Order No.',
                value: DETAIL.order_sn,
            },
            {
                label: 'Payment Amount',
                value: common.parsePrice(DETAIL.pay_amount),
            },
            {
                label: 'Payment Method',
                value: DETAIL.extra.payment_info[0] ? DETAIL.extra.payment_info[0].paymentchannel:'',
            },
            ]
        })
        
        let serviceType = ''
        // type  售后类型1 退款退货 2 退款 3 维修 4 换货
        switch (applyInfo.provide_type) {
            case '1':
                serviceType = 'Return & Refund'
                break;
            case '2':
                serviceType = 'Refund'
                break;
            case '3':
                // serviceType = 'Exchange'
                break;
            case '4':
                serviceType = 'Exchange'
                break;
            default:
            break;
        }
        pageTitle.value = serviceType
        // 我的售后申请模块文案信息
        let myTextData = [
                {
                    label: 'Application Time',
                    value: common.tiemstap(DETAIL.created_at * 1000), 
                },
                {
                    label: 'Service No.',
                    value: DETAIL.sn, 
                },
                {
                    label: 'Service Type',
                    value: serviceType, 
                },
                {
                    label: 'Remark',
                    value: applyInfo.remark, 
                },]
        if(applyInfo.reason_title){
            // 系统自动申请退款不存在原因,用户申请才存在
            myTextData.push({
                    label: 'Reason',
                    value: applyInfo.reason_title,
                })
        }
        // 因为后端接口当不是换货时,也就是申请时没有传换货商品信息时,返回的是一个数组
        if(applyInfo.exchange_goods_info&&!Array.isArray(applyInfo.exchange_goods_info)&&applyInfo.exchange_goods_info.id){
            // 换货的商品信息展示 只有存在换货商品时展示
            detailCardData.value.unshift({
                title: 'Exchange Product Information',
                status: 'exchangGoods',
                goodsData: applyInfo.exchange_goods_info,
                textData: [{
                    label: 'Contact Name',
                    value: applyInfo.receipt_info.firstname + applyInfo.receipt_info.lastname,
                },
                {
                    label: 'Contact Phone No.',
                    value: applyInfo.receipt_info.phone,
                },
                {
                    label: 'Shipping Address',
                    value: applyInfo.receipt_info.explain,
                },
                ]
            })
        }else{
            // 换货类型下不显示退款金额
            myTextData.unshift({
                    label: 'Refund Amount',
                    value: common.parsePrice(applyInfo.refund_amount) ,
                })
        }
        let myApplyFile:any = [] // 我申请模块 文件信息
        handleAttachments(myApplyFile,applyInfo.attachments)
        // 我的申请信息模块,每个详情页固定的模块
        detailCardData.value.unshift({
                title: 'Application Detail',
                status: 'apply info',
                textData: myTextData,
                fileList:myApplyFile
            })
        // 其余展示模块处理
        if (DETAIL.checks) {
            let current: any = {}
            const Arr = DETAIL.checks.reverse()
            Arr.forEach((item: any) => {
                current = {
                    title: item.title,
                    textData: [], 
                    fileList: [],
                    transit: item.transit, // 是否有物流信息，有物流信息则可以查看物流
                    can_edit:item.can_edit
                }
                handleAttachments(current.fileList,item.attachments)
                // 展示的文本信息处理
                for (var key in item.content) {
                    current.textData.push({
                        label: key,
                        value: item.content[key]
                    })
                }
                detailCardData.value.unshift(current)
            });
        }
        // 按钮出现顺序进行排序
        let btnArr: any = []
        if (DETAIL.available_action.some((item: any) => item == 4)) {
            btnArr = [4].concat(DETAIL.available_action.filter((items: any) => items != 4))
        } else {
            btnArr = [].concat(DETAIL.available_action)
        }
        DETAIL.available_action = btnArr
        // 处理显示的按钮 例如确认取消等
        DETAIL.available_action.forEach((item: number) => {
            if (item === 4) {
                btnData.value.push({
                    plain: true,
                    textColor: '#333333',
                    bordersColor: '#999999',
                    radiusSize: '6px',
                    title: 'Cancel',
                    status: item
                })
            } else if (item === 3) {
                btnJurisdictionObj.value.isAvailable = true
                btnData.value.push({
                    plain: true,
                    textColor: '#333333',
                    bordersColor: '#999999',
                    radiusSize: '6px',
                    title: 'Appeal',
                    status: item
                })
            } else if (item === 1) {
                if (DETAIL.available_type === 1 || DETAIL.available_type === 4) {
                    btnData.value.push({
                        plain: true,
                        textColor: '#E04545',
                        bordersColor: '#E04545',
                        radiusSize: '6px',
                        title: 'Confirm',
                        status: item,
                        available_type:DETAIL.available_type
                    })
                }else if(DETAIL.available_type === 5){
                     btnData.value.push({
                        plain: true,
                        textColor: '#E04545',
                        bordersColor: '#E04545',
                        radiusSize: '6px',
                        title: 'Return',
                        status: item,
                        available_type:DETAIL.available_type
                    })
                }


            }
        })
        // 评论按钮
        if (DETAIL.comment_status == 0 && DETAIL.status == 3) {
            btnData.value.push({
                plain: true,
                textColor: '#E04545',
                bordersColor: '#E04545',
                radiusSize: '6px',
                title: 'Review',
            })
        }
    }else{
         Toast(res.msg)
    }
}
getAfterSaleDetail()
// 查看物流轨迹/编辑修改发货方式
const handleLogistics = (row: any, type: string) => {
    if (type === 'edit') {
       router.push({
                name: 'afterSaleExpress',
                params: {
                    transitInfo: JSON.stringify(row),
                    isDetail:1
                },
            })
    } else {
        router.push(`/logistics/${row.express_sn}`)
    }

}
const goNewDetail = () => {
    router.push(`/afterSaleDetailsNew/${route.params.id}?name=state_proces`)
}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_step = _resolveComponent("van-step")!
  const _component_van_steps = _resolveComponent("van-steps")!
  const _component_van_count_down = _resolveComponent("van-count-down")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header, {
      title: `${_unref(pageTitle)} Details`,
      backgroundColor: "#FFFFFF",
      fontColor: "#303133",
      skipPath: _unref(skipPath),
      ios_app: true
    }, {
      right: _withCtx(() => [
        _createElementVNode("div", {
          class: "header-right",
          onClick: goToRule
        }, [
          _createVNode(_component_van_icon, {
            name: "question-o",
            size: "0.5rem"
          }),
          _hoisted_2
        ])
      ]),
      _: 1
    }, 8, ["title", "skipPath"]),
    (_unref(detailAllData)?.actions?.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "go-new-detail",
          onClick: goNewDetail
        }, " Click here to experience the new version. "))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "after-sale-details-tip",
      onClick: jumpShop
    }, [
      _hoisted_3,
      _createElementVNode("u", _hoisted_4, _toDisplayString(_unref(storeName)), 1),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_van_steps, {
          active: _unref(topData).active,
          "finish-icon": "success",
          "icon-size": "20px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["active"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("p", null, _toDisplayString(_unref(topData).afterSaleStatus), 1),
            (_unref(topData).time > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _hoisted_15,
                  _hoisted_16,
                  _createVNode(_component_van_count_down, {
                    time: (1000 * _unref(topData).time),
                    format: "DDd HH:mm:ss"
                  }, null, 8, ["time"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(DeatilCard, {
            isEditAddress: _unref(btnJurisdictionObj).isEditAddress,
            detailData: _unref(detailCardData),
            onLogistics: handleLogistics
          }, null, 8, ["isEditAddress", "detailData"]),
          (_unref(btnJurisdictionObj).isAvailable)
            ? (_openBlock(), _createBlock(KiliButton, {
                key: 0,
                plain: "",
                round: "",
                textColor: '#333',
                bordersColor: '#999',
                title: "Apply for platform intervention",
                onClick: appeal
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(BottomBtn, {
      onClick: handleBtn,
      btnData: _unref(btnData)
    }, null, 8, ["btnData"]),
    _createVNode(_component_van_popup, {
      show: _unref(showDialog),
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : showDialog = $event)),
      class: "after-dialog",
      closeable: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(popupValue)), 1),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(KiliButton, {
            plain: "",
            textColor: "#666666",
            bordersColor: "#99999",
            title: "Contact Seller",
            onClick: handleContact
          }),
          _createVNode(KiliButton, {
            textColor: "#E04545",
            bordersColor: "#E04545",
            title: "Continue",
            loading: _unref(loading),
            onClick: handleContinue
          }, null, 8, ["loading"])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})